import { useCallback } from 'react';

import { useBoolean } from '@dreryk/react-common';
import { Link } from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../../../translations';
import { useFavoriteMedicineCreateCommand } from '../shared/hooks/favoriteMedicine.hooks';

type FavoriteMedicineRestoreLinkProps = {
   readonly onSuccess: VoidFunction;
   readonly medicineId: number;
};

export const FavoriteMedicineRestoreLink = (props: FavoriteMedicineRestoreLinkProps): JSX.Element => {
   const [{ setTrue: setProcessed }, processed] = useBoolean(false);
   const handleSuccess = useCallback(() => {
      props.onSuccess();
      setProcessed();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setProcessed, props.onSuccess]);
   const { execute: createFavoriteMedicine } = useFavoriteMedicineCreateCommand(
      props.medicineId,
      handleSuccess,
      setProcessed
   );

   return (
      <Link
         testId={'restoreFavoriteMedicine'}
         label={medicineSelectorTranslationKeys.table.restore}
         onClick={createFavoriteMedicine}
         block={false}
         disabled={processed}
      />
   );
};
